import React, {Component} from 'react';
import CardNumberField from '../../lib/mdb/card-number-field';
import classnames from 'classnames';


import CVV from './cvv';
import CardExpiryDate from './card-expiry-date'
import DoNotSaveField from "./do-not-save-field";

import {
    initPopover,
    mapCardTypeToCss,
    CardHolderName,
    CvvPopover
} from "../../lib/payment-method-util"

/**
 */
class PaymentMethodDCFields extends Component {

    componentDidMount() {
        initPopover("cc-popover-cvv-link", "popover-cvv");
    }

    render() {
        const {config, paymentMethod, onCardNumberChanged, appComponents} = this.props,
            {paymentConfig, messages} = config,
            dcMethods = paymentConfig.paymentMethods.filter(item => item.categoryCode === 'DC'),
            dcAcceptedCards = dcMethods.map(item => mapCardTypeToCss(item.code));
        const {CardHolderName} = appComponents;
        return (
            <React.Fragment>
                <div className="col-md-6 col-12 DC-field">
                    <div className="pm-logo-row debit-logos">
                        <span className="cc-dc-title">{messages["payment.debit.network.label"]}</span>
                        <img className="logo-star" src={messages["opp.image.pm.star"] || "images/pm/star.png"}
                             alt="STAR"/>
                        <img className="logo-nyce" src={messages["opp.image.pm.nyce"] || "images/pm/nyce.png"}
                             alt="NYCE"/>
                        <img className="logo-pulse" src={messages["opp.image.pm.pulse"] || "images/pm/pulse.png"}
                             alt="Pulse"/>
                    </div>
                </div>
                <div className="col-md-6 col-12 DC-field">
                    <CardNumberField
                        key="paymentMethod-dcAccountNumber"
                        name="paymentMethod.accountNumber"
                        placeholder={messages["opp.cardNumber.tip"]}
                        description={messages["payment.cardNumber.label"]}
                        maxLength="16"
                        className="md-form form-group"
                        labelClass="bootstrap-label"
                        aria-required="true"
                        validations={{
                            required: messages["opp.validation.cardNumber.required"],
                            validCreditCard: messages["opp.validation.cardNumber.invalid"]
                        }}
                        autoComplete="off"
                        postProcess={onCardNumberChanged}
                        rightSideSpanClass={classnames("pm-highlight pm-icon", mapCardTypeToCss(paymentMethod.type))}
                        acceptedCards={dcAcceptedCards}/>
                </div>
                <div className="col-md-3 col-6 DC-field">
                    <CardExpiryDate config={config}/>
                </div>
                { (paymentConfig && !paymentConfig.hideCvvIfOptional) ?
                    <div className="col-md-3 col-6 DC-field">
                        <CVV
                            config={config}
                            paymentMethod={paymentMethod}
                        />
                    </div>
                :<div/>}
                <div className="col-md-6 col-12 DC-field">
                    <CardHolderName
                        key="paymentMethod-dcCardHolderName"
                        messages={messages}
                    />
                </div>
                { (paymentConfig && paymentConfig.cpDoNotSavePmEnabled === 'true') ?
                    <div className="col-12 order-5">
                        <DoNotSaveField
                            messages={messages}
                        />
                    </div>
                    :<div/>}
                <CvvPopover config={config} isCreditCard={false}/>
            </React.Fragment>
        );
    };
}

export default PaymentMethodDCFields
